import React, { useState, useEffect, useRef } from 'react';
import { submitForm } from '../utils/formSubmit';
import Swal from 'sweetalert2';
import './GuideModal.css';

const UsFlag = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 650 390"
    style={{ borderRadius: '2px', display: 'inline-block', verticalAlign: 'middle', width: '22px', height: '14px', flexShrink: 0 }}
  >
    <rect width="650" height="390" fill="#b22234" />
    <path d="M0 30h650M0 90h650M0 150h650M0 210h650M0 270h650M0 330h650" stroke="#fff" strokeWidth="30" />
    <rect width="260" height="210" fill="#3c3b6e" />
    <g fill="#fff">
      <circle cx="26" cy="21" r="9" />
      <circle cx="78" cy="21" r="9" />
      <circle cx="130" cy="21" r="9" />
      <circle cx="182" cy="21" r="9" />
      <circle cx="234" cy="21" r="9" />
      <circle cx="52" cy="52.5" r="9" />
      <circle cx="104" cy="52.5" r="9" />
      <circle cx="156" cy="52.5" r="9" />
      <circle cx="208" cy="52.5" r="9" />
      <circle cx="26" cy="84" r="9" />
      <circle cx="78" cy="84" r="9" />
      <circle cx="130" cy="84" r="9" />
      <circle cx="182" cy="84" r="9" />
      <circle cx="234" cy="84" r="9" />
      <circle cx="52" cy="115.5" r="9" />
      <circle cx="104" cy="115.5" r="9" />
      <circle cx="156" cy="115.5" r="9" />
      <circle cx="208" cy="115.5" r="9" />
      <circle cx="26" cy="147" r="9" />
      <circle cx="78" cy="147" r="9" />
      <circle cx="130" cy="147" r="9" />
      <circle cx="182" cy="147" r="9" />
      <circle cx="234" cy="147" r="9" />
      <circle cx="52" cy="178.5" r="9" />
      <circle cx="104" cy="178.5" r="9" />
      <circle cx="156" cy="178.5" r="9" />
      <circle cx="208" cy="178.5" r="9" />
    </g>
  </svg>
);

const countryList = [
  { name: 'United States', code: '+1', iso: 'us' }
];

const GuideModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    country: 'United States',
    course: 'Quran Memorization Classes',
    notes: '',
    consent: true
  });

  const [selectedCountry, setSelectedCountry] = useState(countryList[0]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const modalRef = useRef(null);
  const countryDropdownRef = useRef(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    const handleClickOutside = (e) => {
      if (countryDropdownRef.current && !countryDropdownRef.current.contains(e.target)) {
        setIsDropdownOpen(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await submitForm('3 Days Free Trial Class Request', {
        fullName: formData.fullName,
        email: formData.email,
        phone: `${selectedCountry.code} ${formData.phone}`,
        country: formData.country,
        course: formData.course,
        notes: formData.notes
      });

      Swal.fire({
        title: 'Trial Request Sent!',
        text: `Thank you, ${formData.fullName}! Your 3 days free trial request has been submitted.`,
        icon: 'success',
        confirmButtonColor: '#006100'
      });

      setFormData({
        fullName: '',
        email: '',
        phone: '',
        country: 'United States',
        course: 'Quran Memorization Classes',
        notes: '',
        consent: true
      });
      onClose();
      window.location.href = '/thank-you-enrollment-successful/';
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: 'Failed to send trial request. Please try again.',
        icon: 'error',
        confirmButtonColor: '#006100'
      });
    } finally {
      setSubmitting(false);
    }
  };

  const filteredCountries = countryList.filter(
    (c) =>
      c.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      c.code.includes(searchQuery)
  );

  return (
    <div className="guide-modal-overlay" onClick={onClose}>
      <div
        className="guide-modal-card"
        ref={modalRef}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          className="guide-modal-close"
          onClick={onClose}
          aria-label="Close modal"
        >
          <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" strokeWidth="2.5" fill="none">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>

        <h3 className="guide-modal-title">SIGNUP FOR 3 DAYS FREE TRIAL CLASS</h3>

        <form onSubmit={handleSubmit} className="guide-modal-form">
          {/* Full Name Input */}
          <div className="guide-modal-group">
            <input
              type="text"
              name="fullName"
              placeholder="Full Name"
              value={formData.fullName}
              onChange={handleChange}
              required
              className="guide-modal-input"
            />
          </div>

          {/* Email Address Input */}
          <div className="guide-modal-group">
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              required
              className="guide-modal-input"
            />
          </div>

          {/* Phone Input with Country Flag Dropdown */}
          <div className="guide-modal-group" ref={countryDropdownRef} style={{ position: 'relative' }}>
            <div className="guide-modal-phone-box">
              <button
                type="button"
                className="guide-modal-country-picker-btn"
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              >
                <UsFlag />
                <span className="guide-modal-arrow">▲</span>
                <span className="guide-modal-code">{selectedCountry.code}</span>
              </button>
              <span className="guide-modal-divider">|</span>
              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
                required
                className="guide-modal-phone-input"
              />
            </div>

            {/* Country Dropdown Menu */}
            {isDropdownOpen && (
              <div className="guide-modal-country-dropdown">
                <div className="guide-modal-search-wrapper">
                  <input
                    type="text"
                    placeholder="Search"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="guide-modal-search-input"
                    autoFocus
                  />
                </div>
                <ul className="guide-modal-country-menu">
                  {filteredCountries.map((c) => (
                    <li
                      key={c.name}
                      className={`guide-modal-country-option ${c.name === selectedCountry.name ? 'guide-modal-country-option--active' : ''}`}
                      onClick={() => {
                        setSelectedCountry(c);
                        setIsDropdownOpen(false);
                        setSearchQuery('');
                      }}
                    >
                      <span className="guide-modal-opt-flag">
                        <UsFlag />
                      </span>
                      <span className="guide-modal-opt-name">{c.name}</span>
                      <span className="guide-modal-opt-code">{c.code}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>

          {/* Country Select Dropdown */}
          <div className="guide-modal-group">
            <select
              name="country"
              value={formData.country}
              onChange={handleChange}
              required
              className="guide-modal-select"
            >
              <option value="United States">United States</option>
              <option value="Canada">Canada</option>
              <option value="United Kingdom">United Kingdom</option>

            </select>
          </div>

          {/* Course Select Dropdown */}
          <div className="guide-modal-group">
            <select
              name="course"
              value={formData.course}
              onChange={handleChange}
              required
              className="guide-modal-select"
            >
              <option value="Quran Memorization Classes">Quran Memorization Classes</option>
              <option value="Noorani Qaida">Noorani Qaida</option>
              <option value="Quran Tajweed Classes">Quran Tajweed Classes</option>
              <option value="Quran Reading Classes">Quran Reading Classes</option>
              <option value="Quran Translation Classes">Quran Translation Classes</option>
            </select>
          </div>

          {/* Textarea */}
          <div className="guide-modal-group">
            <textarea
              name="notes"
              placeholder="Anything you would like to add?"
              value={formData.notes}
              onChange={handleChange}
              rows="3"
              className="guide-modal-textarea"
            ></textarea>
          </div>

          {/* Disclaimer text with checkbox on left top */}
          <div className="guide-modal-disclaimer-wrapper">
            <input
              type="checkbox"
              name="consent"
              id="guide-modal-consent"
              checked={formData.consent !== false}
              onChange={(e) => setFormData(prev => ({ ...prev, consent: e.target.checked }))}
              required
              className="guide-modal-checkbox"
            />
            <label htmlFor="guide-modal-consent" className="guide-modal-disclaimer">
              *By submitting this form, you consent to receiving text messages and emails from al quran lesson concerning your inquiry regarding quran lessons. a representative will reach out to discuss your needs and provide further details. the frequency of messages may vary. You can unsubscribe at any time by replying STOP to text messages or clicking the unsubscribe link in emails. Standard message and data rates may apply.
            </label>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={submitting}
            className="guide-modal-submit-btn"
          >
            {submitting ? 'SUBMITTING...' : 'SIGN UP NOW'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default GuideModal;
